
    /**
     * @description
     *  Modelo de un estado de revendedor.
     *
     * @see gigot-backend/Models/Users/ApplicationUser.cs
     */

export enum ResellerStatus {

    New,
    Active,
    Leader,
    ZoneManager,
    DivisionManager,
    GigotEmployee
}

export const resellerStatusToString = (resellerStatus: ResellerStatus): string => {
	switch (resellerStatus) {
		case ResellerStatus.New:
			return "New";
		case ResellerStatus.Active:
			return "Active";
		case ResellerStatus.Leader:
			return "Leader";
		case ResellerStatus.ZoneManager:
			return "ZoneManager";
		case ResellerStatus.DivisionManager:
			return "DivisionManager";
		case ResellerStatus.GigotEmployee:
			return "GigotEmployee";
		default: {
			return "[Unknown ResellerStatus]";
		}
	}
};
